import { ExternalLink } from "@/components/ExternalLink";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { Clients } from "@/lib/clients";
import { formatNumber } from "@/features/Table/utils";
import { parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type L1TimeSerie = {
  id: number;
  date: string;
  l1_static_datum_name: string;
  l1_static_datum_id?: number;

  fixing: number;
  market_value: number;
  devise: string;
};

const tableName = Tables.L1_TIME_SERIES;
const t = (key: string, defaultValue: string) =>
  i18n.t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });

export const columns: ColumnDef<L1TimeSerie>[] = [
  {
    accessorKey: "id",
    header: t("id", "ID"),
  },
  {
    accessorKey: "date",
    header: t("date", "Date"),
    cell: ({ row }) => {
      return parseDate(row.getValue("date"));
    },
  },
  {
    accessorKey: "l1_static_datum_name",
    header: t("l1_static_datum_name", "Asset"),
    cell: ({ row }) => {
      return (
        <ExternalLink
          href={toWorkspacePath(
            `/admin/${Clients.L1}/${Tables.L1_STATIC_DATA}/${row.original.l1_static_datum_id}`,
          )}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {row.getValue("l1_static_datum_name")}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "fixing",
    header: () => <div className="text-right">{t("fixing", "Fixing")}</div>,
    cell: ({ row }) => {
      const value = row.getValue("fixing") as number;
      const formattedValue =
        value === null || value === undefined || Number.isNaN(value)
          ? ""
          : new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 5,
              maximumFractionDigits: 5,
            }).format(value);

      return <div className="text-right">{formattedValue}</div>;
    },
  },
  {
    accessorKey: "market_value",
    header: () => (
      <div className="text-right">{t("market_value", "Market value")}</div>
    ),
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {formatNumber(row.getValue("market_value"))}
        </div>
      );
    },
  },
  {
    accessorKey: "currency",
    header: t("currency", "Currency"),
  },
  {
    id: "actions",
    header: () => <div className="text-right">{t("actions", "Actions")}</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];

// export const porfolios_audit_columns = getAuditColumns<L1TimeSerie>(porfolios_columns)
